import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useState, useEffect } from 'react';

const slides = [
  {
    src: "https://static.readdy.ai/image/5182a46d43416643563de341c1ddd36e/5294353f41e7ad9e5c4020acfd414dcb.jpeg",
    alt: "한혜진 자연담은",
    title: "자연담은",
    subtitle: "약손콩이",
    subtitleColor: "text-amber-300",
  },
  {
    src: "https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/39229809-5b7c-4182-a3dc-611e808ad51d___1_1.jpg?v=22f7d1d2f402b06ac30da9e380ca1fa7",
    alt: "토카이스 스피루리나 대표이미지",
    title: "자연담은",
    subtitle: "스피루리나",
    subtitleColor: "text-emerald-300",
  },
];

export default function Hero() {
  const { ref, isVisible } = useScrollAnimation();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 슬라이드 이미지 */}
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.src}
            alt={slide.alt}
            className={`w-full h-full object-cover ${idx === 0 ? 'object-top' : 'object-center'}`}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
      ))}

      {/* 슬라이드 인디케이터 */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`transition-all duration-300 rounded-full cursor-pointer ${
              idx === current
                ? 'w-6 h-2 bg-white'
                : 'w-2 h-2 bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>

      <div ref={ref} className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 py-28 md:py-32 text-center">
        <div className={isVisible ? 'animate-fade-in-up' : 'opacity-0'}>
          <span className="inline-block px-3 md:px-4 py-1.5 md:py-2 rounded-full bg-white/10 backdrop-blur-sm text-white text-xs md:text-sm font-semibold mb-4 md:mb-6 border border-white/20">
            🌿 자연이 주는 건강한 에너지
          </span>
          <h1
            className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            {slides[current].title}
            <br />
            <strong className={slides[current].subtitleColor}>{slides[current].subtitle}</strong>
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-7 md:mb-10 max-w-2xl mx-auto leading-relaxed px-2">
            35억 년 자연의 지혜와 한국 전통의 건강 비결을 담은
            <br className="hidden sm:block" />
            프리미엄 건강식품으로 건강한 내일을 시작하세요
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 md:mb-16">
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-7 md:px-8 py-3.5 md:py-4 bg-emerald-600 text-white rounded-full text-sm md:text-base font-semibold hover:bg-emerald-700 hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              제품 둘러보기
            </a>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-7 md:px-8 py-3.5 md:py-4 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm md:text-base font-semibold hover:bg-white/20 border border-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              자세히 알아보기
            </a>
          </div>
        </div>


      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <i className="ri-arrow-down-line text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}
